var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    "data-name": "New Gradient Swatch 1",
    x1: 7.912,
    y1: 487.083,
    x2: 508.783,
    y2: -13.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43f2e9",
    id: "id_114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#0c00ba",
    id: "id_115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc605b",
    id: "id_116"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500.99,433.11,341.85,273.97a8,8,0,0,0-11.31,0l-8.23,8.23-23.63-23.63,85.8-85.8,52.37,10.48a8.027,8.027,0,0,0,7.23-2.19l56.57-56.57a7.983,7.983,0,0,0,2.29-6.54l-5.66-50.91a8,8,0,0,0-13.6-4.78l-58.62,58.62-28.11-5.83-5.83-28.11,58.61-58.62a7.989,7.989,0,0,0-4.77-13.6L394.05,9.06a8.026,8.026,0,0,0-6.54,2.29L330.94,67.92a8.027,8.027,0,0,0-2.19,7.23l10.48,52.37-85.8,85.8L140.54,100.42l-3.75-37.38a8,8,0,0,0-4.39-6.37L41.12,11.19a8.018,8.018,0,0,0-9.23,1.5l-19.2,19.2a8.018,8.018,0,0,0-1.5,9.23L56.67,132.4a8,8,0,0,0,6.37,4.39l37.38,3.75,112.9,112.89-85.8,85.8L75.15,328.75a8.018,8.018,0,0,0-7.23,2.19L11.35,387.51a7.983,7.983,0,0,0-2.29,6.54l5.66,50.91a8,8,0,0,0,13.6,4.78l58.62-58.62,28.11,5.83,5.83,28.11L62.27,483.68a7.989,7.989,0,0,0,4.77,13.6l50.91,5.66c.3.03.59.05.88.05a8,8,0,0,0,5.66-2.34l56.57-56.57a8.027,8.027,0,0,0,2.19-7.23l-10.48-52.37,85.8-85.8,23.63,23.63-8.23,8.23a8,8,0,0,0,0,11.31L433.11,500.99a8,8,0,0,0,11.31,0l56.57-56.57A8,8,0,0,0,500.99,433.11ZM69.02,121.31,28.08,39.14,39.14,28.08l82.17,40.94,3.21,32.06-23.44,23.44Zm46.35,11.55,17.49-17.49L242.12,224.63l-17.49,17.49ZM158.43,376.2a8.007,8.007,0,0,0-2.19,7.22l10.48,52.37L115.9,486.61l-30.55-3.39,49.9-49.9a8,8,0,0,0,2.18-7.29l-7.78-37.47a8.015,8.015,0,0,0-6.21-6.21l-37.47-7.78a8,8,0,0,0-7.29,2.18l-49.9,49.9L25.39,396.1l50.82-50.82,52.37,10.48a8.007,8.007,0,0,0,7.22-2.19L353.57,135.8a8.007,8.007,0,0,0,2.19-7.22L345.28,76.21,396.1,25.39l30.55,3.39-49.9,49.9a8,8,0,0,0-2.18,7.29l7.78,37.47a8.015,8.015,0,0,0,6.21,6.21l37.47,7.78a8,8,0,0,0,7.29-2.18l49.9-49.9,3.39,30.55-50.82,50.82-52.37-10.48a8.007,8.007,0,0,0-7.22,2.19Zm111.45-88.83,17.49-17.49L311,293.51,293.51,311ZM438.76,484.02,290.94,336.2l45.26-45.26L484.02,438.76Z",
    fill: "url(#a)",
    id: "id_113"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceIcon);
export default __webpack_public_path__ + "static/media/maintenance_icon.762ba81ef10f2f7442a3c5160818091d.svg";
export { ForwardRef as ReactComponent };